import storeManager from './store-manager'

export default storeManager
